import { IsUUID, IsEnum, IsString, IsOptional, IsNumber, IsDateString, Min } from 'class-validator';
import { CreateLeadsInterface, UpdateLeadsInterface } from '../../interface/leads/modify-leads.interface';
import { LeadStatus } from '../../interface/leads/leads-response.interface';
import { Brand } from '../../utils/enums.utils';

export class CreateLeadsDto implements CreateLeadsInterface {

  @IsEnum(Brand)
  brand!: Brand;

  @IsOptional()
  @IsString()
  description!: string | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  estimated_amount!: number | null;

  @IsOptional()
  @IsDateString()
  target_date!: string | null;

  @IsEnum(LeadStatus)
  status!: LeadStatus;

  @IsOptional()
  @IsString()
  remarks!: string | null;

  @IsOptional()
  @IsString()
  brand_description!: string | null;

  @IsOptional()
  @IsUUID()
  created_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  updated_by_id!: string | null;

  @IsUUID()
  client_id!: string;
}

export class UpdateLeadsDto implements UpdateLeadsInterface {

  @IsUUID()
  id!: string;

  @IsOptional()
  @IsEnum(Brand)
  brand?: Brand;

  @IsOptional()
  @IsString()
  description?: string | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  estimated_amount?: number | null;

  @IsOptional()
  @IsDateString()
  target_date?: string | null;

  @IsOptional()
  @IsEnum(LeadStatus)
  status?: LeadStatus;

  @IsOptional()
  @IsString()
  remarks?: string | null;

  @IsOptional()
  @IsString()
  brand_description?: string | null;

  @IsUUID()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  client_id?: string;
}